import { Box } from '@chakra-ui/react'
import styled from '@emotion/styled'

export const Form = styled.form`
    min-height: 480px;
    max-height: calc(100vh - 8rem);
    display: flex;
    flex-direction: column;
    overflow-y: auto;
`

export const FormActions = styled(Box)`
    position: sticky;
    bottom: 0;
    background-color: var(--chakra-colors-white);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: var(--chakra-space-8);
    margin-top: auto;
    margin-inline: var(--chakra-space-8);
    padding-top: var(--chakra-space-8);
`
